import type { FC, ReactNode } from 'react'

const Grain: FC = (): ReactNode => {
    return <div aria-hidden='true' className='umbra-grain pointer-events-none fixed inset-0 z-[60]' />
}

export default Grain
